/* onboarding.service.ts */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  private apiUrl = environment.apiUrlNewCall;

  constructor(private http: HttpClient) {}

  /**
   * Create onboarding record in Salesforce
   */
  createOnboardingRecord(data: any): Observable<any> {
    return this.http.post(
      `${this.apiUrl}onboarding/createOnboardingRecord`,
      data
    );
  }

  createMemberOnboardingRecord(data: any): Observable<any> {
    return this.http.post(
      `${this.apiUrl}onboarding/createMemberOnboardingRecord`,
      data
    );
  }
}
